// import { CrudOperators } from "@abhimanyu24/mr-react-core";

import { CrudOperators } from "@refinedev/core";

export const mapOperator = (operator: CrudOperators): string => {
  switch (operator) {
    case "ne":
    case "gte":
    case "lte":
      return `_${operator}`;
    case "contains":
      return "_like";
    case "eq":
    default:
      return "";
  }
};


// import { CrudOperators } from "@refinedev/core";

// export const mapOperator = (operator: CrudOperators): string => {
//     switch (operator) {
//         case "ne":
//         case "gte":
//         case "lte":
//             return `_${operator}`;
//         case "contains":
//             return "_like";
//         case "eq":
//         default:
//             return "";
//     }
// };
